import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: "gh-example-input-component",
  templateUrl: "./example-input.component.html",
  styleUrls: ["example-input.component.less"],
})
export class ExampleInputComponent {
  public value?: string;

  public form: FormGroup;

  public constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      comment: [null, [Validators.maxLength(100)]],
    });
  }
}
